import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { fadeIn, slideIn } from '../../utils/gsapAnimations';

function ShippingInfo() {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    fadeIn(textRef.current, 0.3);
    slideIn(imageRef.current, 'right', 0.5);
  }, []);

  return (
    <div className="flex flex-col lg:flex-row items-center py-12 px-4 gap-8 bg-burgundy text-cream">
      <div ref={textRef} className="w-full lg:w-1/2 text-center lg:text-left">
        <h2 className="text-2xl font-lora font-semibold mb-4">Shipping Information</h2>
        <p className="text-poppins mb-4">
          We ship from our eco-friendly warehouse in New York. All orders are processed within 1-2
          business days. You’ll receive a tracking number via email once your order ships. For
          international orders, please note that customs fees may apply.
        </p>
        <Link to="/contact">
          <Button>Contact Us</Button>
        </Link>
      </div>
      <div ref={imageRef} className="w-full lg:w-1/2">
        <img
          src="https://via.placeholder.com/600x400?text=Shipping+Info"
          alt="Shipping Info"
          className="w-full h-auto rounded-lg"
        />
      </div>
    </div>
  );
}

export default ShippingInfo;